import React from 'react';

import { useStart, useStop, useRemove } from 'scenes/Integrations/data';

import { Actions } from './Actions';

import { getConfigurationTypeId } from 'scenes/Integrations/utils';
export const IntegrationActions = ({
  actions,
  data,
  onDuplicate,
  onEdit,
  onRemove,
  type = getConfigurationTypeId(data),
}) => {
  const [start] = useStart(type);
  const [stop] = useStop(type);
  const [remove] = useRemove(type);

  const handleDuplicate = () => onDuplicate?.(data);

  const handleEdit = () => onEdit?.(data);

  const handleStart = async () => {
    await start(data);
  };

  const handleStop = async () => {
    await stop(data);
  };

  const handleRemove = async () => {
    await remove(data);
    onRemove?.(data);
  };

  return (
    <Actions
      actions={actions}
      onDuplicate={handleDuplicate}
      onEdit={handleEdit}
      onStart={handleStart}
      onStop={handleStop}
      onRemove={handleRemove}
    />
  );
};

export default IntegrationActions;
